import React from "react";
import {SelectId} from "./SelectId";
import {Select} from "./Select";

const campaignStatusOptions = [
    { id: 'Draft', label: 'Draft' },
    { id: 'Quote', label: 'Quote' },
    { id: 'Cancelled', label: 'Cancelled' },
    { id: 'Confirmed', label: 'Confirmed' },
    { id: 'To invoice', label: 'To invoice' },
    { id: 'Invoiced', label: 'Invoiced' },
    { id: 'Paid', label: 'Paid' },
    { id: 'Part Paid', label: 'Part Paid' },
    { id: 'Part Invoiced', label: 'Part Invoiced' }
];
export function CampaignStatusSelect(props) {
    const { includeInProduction, ...rest } = props;
    // `In Production` is only offered for creative-studio campaigns; the default
    // list stays unchanged for every other consumer.
    const options = includeInProduction
        ? [...campaignStatusOptions, { id: 'In Production', label: 'In Production' }]
        : campaignStatusOptions;
    return rest.valueIsId?
        <SelectId options={options} {...rest} labelField="label" />:
        <Select options={options} {...rest} labelField="label" />;
}